import { isSupportedLang, toLocale } from '@/utils/lib/i18nUtils';
import { AllowedUrlParams } from '@/constants';
import { Locale } from '@/i18n';
import pinia from '@/stores';
import type { RouteLocationNormalized } from 'vue-router';
import { useI18nStore } from '@/stores/i18n';

export function applyLocale(to: RouteLocationNormalized): void {
  const locale: Locale | undefined = toLocale(to.query[AllowedUrlParams.lang] as Locale);
  if (!locale) return;
  if (locale && !isSupportedLang(locale)) {
    console.warn(`Tried to load unsupported language: "${locale}". Must be "${Locale.NL}" or "${Locale.EN}"`);
    return;
  }

  useI18nStore(pinia).set(locale);
}
